import { NumberValue, StringValue } from '@coveo/bueno';
import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { isErrorResponse, } from '../../api/search/search-api-client.js';
import { validatePayload } from '../../utils/validate-payload.js';
import { buildSearchAndFoldingLoadCollectionRequest as legacyBuildSearchAndFoldingLoadCollectionRequest } from '../search-and-folding/legacy/search-and-folding-request.js';
import { buildSearchAndFoldingLoadCollectionRequest } from '../search-and-folding/search-and-folding-request.js';
export const foldingOptionsSchemaDefinition = {
    collectionField: new StringValue({ emptyAllowed: false, required: false }),
    parentField: new StringValue({ emptyAllowed: false, required: false }),
    childField: new StringValue({ emptyAllowed: false, required: false }),
    numberOfFoldedResults: new NumberValue({ min: 0, required: false }),
};
export const registerFolding = createAction('folding/register', (payload) => validatePayload(payload, foldingOptionsSchemaDefinition));
export const loadCollection = createAsyncThunk('folding/loadCollection', async (collectionId, { getState, rejectWithValue, extra: { apiClient, navigatorContext } }) => {
    const state = getState();
    const sharedWithSearchRequest = state.configuration.analytics.analyticsMode === 'legacy'
        ? await legacyBuildSearchAndFoldingLoadCollectionRequest(state)
        : buildSearchAndFoldingLoadCollectionRequest(state, navigatorContext);
    const response = await apiClient.search({
        ...sharedWithSearchRequest,
        q: getQForHighlighting(state),
        enableQuerySyntax: true,
        cq: `@${state.folding.fields.collection}="${collectionId}"`,
        filterField: state.folding.fields.collection,
        childField: state.folding.fields.parent,
        parentField: state.folding.fields.child,
        filterFieldRange: 100,
    }, { origin: 'foldingCollection' });
    if (isErrorResponse(response)) {
        return rejectWithValue(response.error);
    }
    return {
        collectionId,
        results: response.success.results,
        searchUid: response.success.searchUid,
        rootResult: state.folding.collections[collectionId]
            .result,
    };
});
function getQForHighlighting(state) {
    // This piece of code serves the following purpose:
    // Inject the "original" query "q" to get proper keywords highlighting when loading a full collection
    // However, the intent behind this feature is to load "every results available for this collection", regardless of other end user filters (including the search box itself)
    // For that reason, we force enable query syntax + inject an `OR @uri` expression in the query.
    if (state.query.q === '') {
        return '';
    }
    return state.query.enableQuerySyntax
        ? `${state.query.q} OR @uri`
        : `( <@- ${state.query.q} -@> ) OR @uri`;
}
